/** @format */
/** @format */

import React, { FC, useState, useRef, useMemo } from 'react'
import styled from 'styled-components'
import {
  _$,
  Form,
  FormItem,
  Input,
  ButtonGroup,
  Select,
  Option,
  Button,
  Icon,
  Message,
  Switch,
  Skeleton,
  Checkbox,
  Card,
  Tooltip
} from '@king-design/react'
import { AddButon, CustomPageContainer } from 'src/components'
import variable from 'src/static/styles/var'
import {
  initEditPolicyRule,
  EditPolicyProps,
  initTemplateValues,
  initPolictValues,
  jsonToYaml,
  validateEditEmpty,
  initVisualRule
} from 'src/pages/PrometheusMonitor/Alarm/constants'
import RuleFormItem from 'src/pages/PrometheusMonitor/Alarm/components/RuleFormItem'
import VisualRuleList from 'src/pages/PrometheusMonitor/Alarm/components/VisualRule'
import RulePreview from 'src/pages/PrometheusMonitor/Alarm/components/RulePreview'
import AlarmCallBack, { handleCallbackType } from 'src/components/AlarmCallBack/new'
import AlarmReciver, { handleWayToChannels } from 'src/components/AlarmReciver/new'
import YamlCodemirror from 'src/components/YamlCodemirror'
import { useHistory, useLocation } from 'react-router'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
import {
  getPrometheusAlertPolicyList,
  createPrometheusAlertPolicy,
  updatePrometheusAlertPolicy,
  getPrometheusAlertTemplate,
  getPrometheusAlertTemplateList,
  createPrometheusAlertTemplate,
  updatePrometheusAlertTemplate,
  validateAlertRule
} from 'src/api/ApiPrometheusAlarm'
import { GetProductList } from 'src/api/ApiAlarmServer'
import { cloneDeep } from 'lodash'
import { useAsync, useAsyncFn } from 'react-use'
import useNavRegion from 'src/hooks/useNavRegion'
import {
  bps_ops,
  getMetricUnitOptions,
  handleMetricUnits,
  handleUnitsValue
} from 'src/containers/MonitorCreate/AlarmRule/constants'
import yaml from 'js-yaml'
export const ShieldTimeTypeOpts = {
  1: '永久生效',
  2: '绝对时间范围',
  3: '相对时间范围(每天循环)'
}

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

interface AlarmEditPageProps {
  className?: string
}
const AlarmEditPage: FC<AlarmEditPageProps> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const policyid = query.get('policyid')
  const rulename = query.get('rulename')
  const page = query.get('page')
  const templateid = query.get('templateid')
  const tab = query.get('tab')
  const urlProductType = query.get('productType')
  // form表单
  const formRef = useRef(null)
  const [formValue, setFormValue] = useState<EditPolicyProps>({
    ...initPolictValues,
    CreateType: page === 'policy' ? 'visual' : 'page',
    BuilderProduct: urlProductType ? parseInt(urlProductType) : undefined
  })
  const [template, setTemplate] = useState()
  // PromQL数据预览
  const [prviewVisible, setPrviewVisible] = useState(false)
  const [prviewExpr, setPrviewExpr] = useState('')
  // 控制台region
  const region = useNavRegion()
  // 初始化
  const { value: defaultValue, loading } = useAsync(async () => {
    if (policyid) {
      const result = await getPrometheusAlertPolicyList({
        PolicyID: parseInt(policyid)
      })
      if (result?.Polices?.length) {
        const policy = result.Polices[0]
        setFormValue({
          ...initPolictValues,
          CreateType: policy?.BuilderRules ? 'visual' : 'page',
          BuilderRules:
            policy.BuilderRules?.map(rule => {
              return {
                ...rule,
                TriggerRules: rule.TriggerRules.map(metric => {
                  const { Metric, Threshold, Units, DisplayUnits } = metric
                  return {
                    ...metric,
                    Threshold: handleMetricUnits(
                      policy?.BuilderProduct,
                      Metric,
                      Threshold,
                      Units,
                      DisplayUnits
                    )
                  }
                })
              }
            }) || [],
          BuilderProduct: policy.BuilderProduct,
          Name: policy.Name,
          InstanceIDs: policy.InstanceIDs,
          Recipients: policy.Recipients.map(item => ({
            ...item,
            ContactChannels: handleWayToChannels(item.ContactChannels || item.ContactWay)
          })),
          URLNotices: policy.URLNotices || handleCallbackType(policy.WebHooks) || [],
          Yaml: jsonToYaml(policy.Rules),
          Rules: policy.Rules.map(rule => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1)
            }
          }),
          SaveAsTemplate: false
        })
        return policy
      } else {
        setFormValue({ ...initPolictValues })
        Message.error(_$('策略不存在'))
        return {}
      }
    } else if (templateid) {
      const result = await getPrometheusAlertTemplate({
        TemplateID: parseInt(templateid)
      })
      if (result?.AlertTemplate) {
        const { Name, Rules } = result?.AlertTemplate
        setFormValue({
          CreateType: 'page',
          Name,
          Yaml: '',
          Rules: Rules?.map((rule, index) => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1)
            }
          }) || [initEditPolicyRule]
        })
        return result?.AlertTemplate
      } else {
        setFormValue({ ...initTemplateValues })
        Message.error(_$('模板不存在'))
        return {}
      }
    }
  }, [policyid, rulename, templateid])
  // 产品列表
  const { value: productList, loading: productListLoading } = useAsync(async () => {
    const result = await GetProductList()
    return result?.data?.productList || []
  }, [])

  // 账户下实例
  const { value: instances, loading: instancesLoading } = useAsync(async () => {
    if (region && page !== 'template') {
      const result = await getPromethuesInstance({
        SearchRegion: region
      })
      return (
        result?.InstancesSet?.map(item => {
          return { name: item.InstanceName, id: item.ControllerID }
        }) || []
      )
    } else {
      return []
    }
  }, [region, page])

  // 模板列表
  const { value: templateList, loading: templateListLoading } = useAsync(async () => {
    const result = await getPrometheusAlertTemplateList({
      Page: 1,
      PageSize: 9999,
      Type: page === 'template' ? 1 : 0
    })
    return result?.AlertTemplates
  }, [page])

  // YAML 校验
  const [, validateYaml] = useAsyncFn(async yaml => {
    const result = await validateAlertRule({ RuleGroup: yaml })
    return result?.Rules
  }, [])

  // 查询模板详情
  const [, templateDetailFetch] = useAsyncFn(
    async TemplateID => {
      const result = await getPrometheusAlertTemplate({
        TemplateID
      })
      if (result?.AlertTemplate) {
        setFormValue({
          ...formValue,
          Yaml: jsonToYaml(result.AlertTemplate.Rules),
          Rules: result.AlertTemplate.Rules?.map(rule => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1),
              RuleID: undefined
            }
          }) || [initEditPolicyRule]
        })
        Message.success(_$('模板详情加载成功'))
      }
      return result?.Rules
    },
    [formValue]
  )

  // 修改表单
  const onChangeValues = values => {
    setFormValue({
      ...formValue,
      ...values
    })
  }

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    try {
      if (validate) {
        const {
          Name,
          InstanceIDs,
          Recipients,
          BuilderProduct,
          BuilderRules,
          URLNotices,
          CreateType,
          Yaml,
          Rules,
          SaveAsTemplate,
          TemplateName
        } = formValue
        let params: Partial<EditPolicyProps> = {
          Name: Name
        }
        if (CreateType === 'yaml') {
          const validateYaml = await validateAlertRule({ RuleGroup: Yaml })
          if (validateYaml?.Rules?.length) {
            params.Rules = validateYaml?.Rules.map((item, index) => {
              const { Alert, Expr, Labels, Annotations, For } = item
              return {
                RuleID: Rules[index]?.RuleID || 0,
                State: Rules[index]?.State || 1,
                Alert,
                Expr,
                For,
                Labels,
                Annotations
              }
            })
          } else {
            return true
          }
        } else if (CreateType === 'page') {
          params.Rules = Rules.map((item, index) => {
            const { State, Alert, Expr, For, Labels, Annotations, ForUnit, RuleID } = item
            return {
              Alert,
              RuleID,
              Expr,
              For: `${For}${ForUnit}`,
              Labels,
              Annotations,
              State
            }
          })
        } else if (CreateType === 'visual') {
          params.BuilderProduct = BuilderProduct
          params.BuilderRules = BuilderRules?.map(rule => {
            return {
              ...rule,
              TriggerRules: rule.TriggerRules.map(metric => {
                const { Metric, Threshold, Units, DisplayUnits } = metric
                const unitOpts = getMetricUnitOptions(BuilderProduct, Metric, Units)
                let value = Threshold
                if (unitOpts?.length) {
                  value = handleUnitsValue(Threshold, DisplayUnits, Units, unitOpts)
                } else if (Units === 'bps') {
                  value = handleUnitsValue(Threshold, DisplayUnits, Units, bps_ops)
                }
                return {
                  ...metric,
                  Threshold: parseFloat(value as unknown as string)
                }
              })
            }
          })
        }
        let result
        // 告警模板
        if (page === 'template') {
          result = templateid
            ? await updatePrometheusAlertTemplate({
                ID: parseInt(templateid),
                ...params
              })
            : await createPrometheusAlertTemplate(params)
        } else {
          // 告警策略
          params = {
            ...params,
            PolicyType: 1,
            InstanceIDs: InstanceIDs,
            Recipients: Recipients.filter(item => !!item.ContactID),
            URLNotices,
            SaveAsTemplate,
            TemplateName: SaveAsTemplate ? TemplateName : ''
          }
          result = policyid
            ? await updatePrometheusAlertPolicy({
                PolicyID: parseInt(policyid),
                ...params
              })
            : await createPrometheusAlertPolicy(params)
        }
        if (result.code !== 'error') {
          Message.success(policyid || templateid ? _$('更新成功') : _$('新建成功'))
          history.push(`/monitor/prometheusmonitor/alarm?tab=${tab}`)
        }
      } else {
        setFormValue(pre => ({ ...pre }))
      }
      return true
    } catch (e) {
      return false
    }
  }

  // 全部收起/展开
  const allExpand = useMemo(() => {
    return formValue?.Rules.every(item => item.Expand)
  }, [formValue])

  // 判断是否支持电话
  const showPhone = useMemo(() => {
    if (formValue.CreateType === 'page') {
      if (formValue.Rules?.length) {
        const find = formValue.Rules.find(item => item.Labels?.[0].Value === 'critical')
        return !!find
      } else {
        return false
      }
    } else if (formValue.CreateType === 'yaml') {
      const yamlRules = yaml.load(formValue.Yaml)?.rules
      const find = yamlRules?.find(item => item.labels?.severity === 'critical')
      return !!find
    } else {
      const find = formValue.BuilderRules?.find(item => {
        return item.Severity === 'critical'
      })
      return !!find
    }
  }, [formValue.CreateType, formValue.Rules, formValue.Yaml, formValue.BuilderRules])

  const pageTitle = useMemo(() => {
    if (page === 'template') {
      return templateid ? _$('编辑告警模板') : _$('新建告警模板')
    } else {
      return policyid ? _$('编辑告警策略') : _$('新建告警策略')
    }
  }, [page, policyid, templateid])

  return (
    <div className={className}>
      <CustomPageContainer showBack title={formValue.Name || pageTitle}>
        <Card type="none">
          {loading || productListLoading || instancesLoading || templateListLoading ? (
            <Skeleton
              loading={loading || productListLoading || instancesLoading || templateListLoading}
            ></Skeleton>
          ) : (
            <Form className="form_container" starOnRequired ref={formRef} labelWidth={110}>
              <FormItem
                label={_$('新建类型')}
                value={formValue.CreateType}
                rules={{ required: true }}
              >
                <ButtonGroup
                  checkType="radio"
                  value={formValue.CreateType}
                  onChangeValue={async value => {
                    if (value === 'yaml') {
                      const isEmpty = validateEditEmpty(formValue.Rules)
                      const yaml = isEmpty ? _$('initYaml') : jsonToYaml(formValue.Rules)
                      onChangeValues({
                        CreateType: value,
                        Yaml: yaml
                      })
                    } else if (value === 'page') {
                      if (formValue.CreateType === 'yaml' && formValue.Yaml) {
                        const validate = await validateYaml(formValue.Yaml)
                        if (validate) {
                          const pageRules = validate.map((item, index) => {
                            const rule = formValue.Rules[index]
                            return {
                              ...item,
                              RuleID: rule?.RuleID || 0,
                              State: rule?.State || 1,
                              Expand: true,
                              For: (item.For as string)?.slice(0, -1),
                              ForUnit: (item.For as string)?.slice(-1)
                            }
                          })
                          onChangeValues({
                            CreateType: value,
                            Rules: pageRules
                          })
                        }
                      } else {
                        onChangeValues({
                          CreateType: value,
                          Rules: [initEditPolicyRule]
                        })
                      }
                    } else {
                      onChangeValues({
                        CreateType: value,
                        Rules: [initEditPolicyRule]
                      })
                    }
                  }}
                >
                  {page === 'policy' ? <Button value="visual">{_$('可视化编辑')}</Button> : null}
                  <Button value="page">{_$('页面编辑')}</Button>
                  <Button value="yaml">{_$('YAML编辑')}</Button>
                </ButtonGroup>
                <Tooltip
                  content={_$(
                    '若您在保存前，于页面编辑&YAML编辑均填写数据，最终将以YAML编辑提交内容为准'
                  )}
                >
                  <Icon className="icon ion-help-circled" />
                </Tooltip>
              </FormItem>
              <FormItem
                label={page === 'template' ? _$('模板名称') : _$('策略名称')}
                value={formValue.Name}
                rules={{ required: true, userName: true }}
              >
                <Input
                  onChangeValue={value => {
                    onChangeValues({
                      Name: value,
                      TemplateName:
                        page === 'policy' && !policyid && formValue.SaveAsTemplate ? value : ''
                    })
                  }}
                  placeholder={page === 'template' ? _$('请输入模板名称') : _$('请输入策略名称')}
                  value={formValue.Name}
                ></Input>
              </FormItem>
              {page === 'policy' ? (
                <FormItem
                  label={_$('关联资源')}
                  value={formValue.InstanceIDs}
                  rules={{ required: true }}
                >
                  <Select
                    value={formValue.InstanceIDs}
                    clearable
                    filterable
                    multiple
                    onChangeValue={value => {
                      onChangeValues({ InstanceIDs: value })
                    }}
                  >
                    {instances?.map(item => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              ) : null}
              {formValue.CreateType !== 'visual' ? (
                <FormItem
                  label={page === 'template' ? _$('系统模板') : _$('告警模板')}
                  value={template}
                >
                  <Select
                    value={template}
                    clearable
                    filterable
                    onChangeValue={value => {
                      setTemplate(value)
                      if (value) {
                        templateDetailFetch(value)
                      }
                    }}
                  >
                    {templateList?.map(item => (
                      <Option key={item.ID} value={item.ID}>
                        {item.Name}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              ) : (
                <>
                  <FormItem
                    label={_$('产品类型')}
                    value={formValue.BuilderProduct}
                    rules={{ required: true }}
                  >
                    <Select
                      value={formValue.BuilderProduct}
                      placeholder={_$('请选择产品类型')}
                      filterable
                      disabled={!!defaultValue?.BuilderRules?.length}
                      onChangeValue={value => {
                        onChangeValues({ BuilderProduct: value, BuilderRules: [initVisualRule] })
                      }}
                    >
                      {productList?.map(item => (
                        <Option key={item.productType} value={item.productType}>
                          {item.productName}
                        </Option>
                      ))}
                    </Select>
                  </FormItem>
                  <FormItem
                    className="form_item_visual"
                    label={_$('告警规则')}
                    value={formValue.BuilderRules}
                    rules={{
                      required: true
                    }}
                  >
                    <VisualRuleList
                      ruleValue={formValue.BuilderRules}
                      productType={formValue.BuilderProduct}
                      onChangeValue={value => {
                        onChangeValues({ BuilderRules: value })
                      }}
                    />
                  </FormItem>
                </>
              )}
              {formValue.CreateType === 'page' ? (
                <FormItem
                  className="form_item_rules"
                  label={_$('告警规则')}
                  value={formValue.Rules}
                  rules={{
                    required: true
                  }}
                >
                  <div className="rules_content">
                    {formValue.Rules.length > 1 ? (
                      <div className="all_expand">
                        <Switch
                          on={_$('全部收起')}
                          off={_$('全部展开')}
                          width="90"
                          height="22"
                          value={allExpand}
                          onChangeValue={value => {
                            onChangeValues({
                              Rules: formValue.Rules.map(item => ({
                                ...item,
                                Expand: value
                              }))
                            })
                          }}
                        />
                      </div>
                    ) : null}
                    {formValue.Rules.map((item, index) => {
                      return (
                        <RuleFormItem
                          key={item.RuleID || index}
                          index={index}
                          page={page}
                          ruleValue={item}
                          ruleNameUnique={value => {
                            let count = 0
                            if (value && formValue?.Rules?.length) {
                              formValue?.Rules.find(item => {
                                if (item.Alert === value) {
                                  count++
                                }
                                return count > 1
                              })
                              return count === 1 || _$('单个策略内，规则名称不允许重复')
                            }
                            return true
                          }}
                          onChangeValue={(values, index) => {
                            if (values) {
                              const copyRules = cloneDeep(formValue.Rules)
                              copyRules[index] = {
                                ...copyRules[index],
                                ...values
                              }
                              onChangeValues({
                                Rules: copyRules
                              })
                            } else {
                              const copyRules = cloneDeep(formValue.Rules)
                              if (copyRules.length === 1) {
                                Message.warning(_$('至少保留一条告警规则'))
                              } else {
                                copyRules.splice(index, 1)
                                onChangeValues({
                                  Rules: copyRules
                                })
                              }
                            }
                          }}
                          onPreview={expr => {
                            setPrviewVisible(true)
                            setPrviewExpr(expr)
                          }}
                        />
                      )
                    })}
                    <AddButon
                      text={_$('新建规则')}
                      disabled={formValue.Rules?.length >= 10}
                      onClick={() => {
                        onChangeValues({
                          Rules: formValue.Rules.concat(initEditPolicyRule)
                        })
                      }}
                    />
                  </div>
                </FormItem>
              ) : null}
              {formValue.CreateType === 'yaml' ? (
                <FormItem
                  className="form_item_yaml"
                  label={_$('告警规则')}
                  value={formValue.Yaml}
                  rules={{
                    required: true,
                    yaml: true
                  }}
                >
                  <YamlCodemirror
                    value={formValue.Yaml}
                    onChange={value => {
                      onChangeValues({ Yaml: value })
                    }}
                  />
                </FormItem>
              ) : null}
              {page !== 'template' ? (
                <>
                  <FormItem
                    slotLabel={
                      <>
                        {_$('通知对象')}
                        <Tooltip
                          hoverable
                          slotContent={
                            <>
                              <div>{_$('紧急（Critical）：邮件、短信、电话均会通知。')}</div>
                              <div>{_$('严重（Error）：邮件、短信通知。')}</div>
                              <div>{_$('警告（Warning）：仅邮件通知。')}</div>
                            </>
                          }
                        >
                          <Icon className="icontip ion-help-circled" />
                        </Tooltip>
                      </>
                    }
                    value={formValue.Recipients}
                    messages={{
                      required: _$('通知对象&告警回调至少选择一项配置')
                    }}
                    rules={{
                      required: formValue.URLNotices.length === 0
                    }}
                  >
                    <AlarmReciver
                      style={{ width: 700 }}
                      showPhone={showPhone}
                      value={formValue.Recipients}
                      onChange={value => {
                        onChangeValues({ Recipients: value })
                      }}
                    />
                  </FormItem>
                  <FormItem
                    label={_$('告警回调')}
                    value={formValue.URLNotices}
                    messages={{
                      required: _$('通知对象&告警回调至少选择一项配置')
                    }}
                    rules={{
                      required: formValue.Recipients.length === 0
                    }}
                  >
                    <AlarmCallBack
                      style={{ width: 700 }}
                      value={formValue?.URLNotices}
                      onChange={value => {
                        onChangeValues({ URLNotices: value })
                      }}
                    />
                  </FormItem>
                  {!policyid && formValue.CreateType !== 'visual' ? (
                    <>
                      <FormItem hideLabel>
                        <Checkbox
                          value={formValue.SaveAsTemplate}
                          onChangeValue={value => {
                            onChangeValues({
                              SaveAsTemplate: value,
                              TemplateName: formValue.TemplateName
                                ? formValue.TemplateName
                                : formValue.Name
                            })
                          }}
                        >
                          {_$('保存当前告警策略为模板')}
                        </Checkbox>
                        <Tooltip
                          content={_$(
                            '默认将告警策略名称设置为模板名称。保存后可前往告警模板页编辑模板名称及内容。'
                          )}
                        >
                          <Icon
                            style={{ lineHeight: '16px', marginTop: 4 }}
                            className="icon ion-help-circled"
                          />
                        </Tooltip>
                      </FormItem>

                      {formValue.SaveAsTemplate ? (
                        <FormItem
                          label={_$('模板名称')}
                          value={formValue.TemplateName}
                          rules={{ required: formValue.SaveAsTemplate, userName: true }}
                        >
                          <Input
                            onChangeValue={value => {
                              onChangeValues({ TemplateName: value })
                            }}
                            placeholder={_$('请输入模板名称')}
                            value={formValue.TemplateName}
                          ></Input>
                        </FormItem>
                      ) : null}
                    </>
                  ) : null}
                </>
              ) : null}
            </Form>
          )}
          <div className="bottom_action">
            <Button onClick={() => formSubmit()} type="primary">
              {_$('确认')}
            </Button>
            <Button
              onClick={() => {
                history.goBack()
              }}
              type="default"
            >
              {_$('取消')}
            </Button>
          </div>
        </Card>
      </CustomPageContainer>
      {/* PromQL数据预览 Dialog */}
      <RulePreview
        visible={prviewVisible}
        onClose={() => {
          setPrviewVisible(false)
          setPrviewExpr('')
        }}
        expr={prviewExpr}
      />
    </div>
  )
}

export default styled(AlarmEditPage)`
  .k-icon {
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    &:hover {
      color: ${variable.primaryColor};
    }
  }
  position: relative;
  .k-card {
    .k-card-body {
      height: calc(100vh - 228px);
      overflow-y: auto;
      position: relative;
    }
  }
  .form_container {
    .ion-help-circled {
      margin-left: 8px;
      line-height: 32px;
    }
  }
  .all_expand {
    line-height: 20px;
    margin-top: 5px;
    margin-bottom: 8px;
  }
  .form_item_rules {
    .rules_content {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  .form_item_yaml {
    .k-form-content {
      width: 700px;
    }
  }
  .form_item_visual {
    & > .k-form-content {
      width: calc(100% - 140px);
    }
  }
  .k-radio {
    margin-right: 8px;
  }

  .bottom_action {
    display: flex;
    justify-content: flex-end;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    padding: 16px 0;
    background: #ffffff;
    padding-right: 16px;
    z-index: 98;
    border-radius: 6px 6px 0 0;
    button {
      font-size: 14px;
      margin-left: 8px;
    }
  }
`
